import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { useNavigate, useLocation } from 'react-router-dom';
import { dbPost } from '../../apis/commonApi';
import { NumericFormat } from 'react-number-format';
import { isValidEmail } from '../../services/UtilService';
import MemberController from '../../controllers/member/MemberController';
import { nlPost } from '../../apis/notLoginApi';

const AdminUserInfo = () => {
  useEffect(() => {
    document.title = '사용자관리';
  }, []);

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);

  const validateService = new ValidateService(modalService);
  const navigate = useNavigate();
  const gridRef = useRef(null);
  const [valueObj, setValueObj] = useState(null);
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [searchMethod, setSearchMethod] = useState('entNm');
  const [searchValue, setSearchValue] = useState('');
  const [entData, setEntData] = useState([]);
  const [dplChkBool, setDplChkBool] = useState(true);
  const [userEmlChg, setUserEmlChg] = useState(false);

  const controller = useMemo(() => {
    return new MemberController(
      { store, updateStore },
      modalService,
      validateService,
      navigate,
      [gridRef],
      {
        valueObj,
        setValueObj,
      }
    );
  }, [store, modalService, validateService]);

  const [formData, setFormData] = useState({
    userId: '',
    userType: '',
  });

  useEffect(() => {
    if (location.state && location.state.userId) {
      if (store) {
        setFormData(prevFormData => ({
          ...prevFormData,
          userId: location.state.userId || '',
          userType: location.state.userType || '',
        }));
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (formData.userId != null && formData.userId !== '') {
      getUserInfo();
    }
  }, [formData.userId]);

  const getUserInfo = async () => {
    const url = '/member/getUserInfo.do';
    const param = {
      userId: formData.userId.replace(/\s+/g, ''),
      userType: formData.userType,
    };
    await dbPost(url, param)
      .then(response => {
        setFormData(prevFormData => ({
          ...prevFormData,
          userSn: response.userSn || '',
          userNm: response.userNm || '',
          userTelno: response.userTelno || '',
          userMblTelno: response.userMblTelno || '',
          userEml: response.userEml || '',
          userOrgnlEml: response.userEml || '',
          entSn: response.entSn || '',
          entNm: response.entNm || '',
          brno: response.brno || '',
          useYn: response.useYn || '',
          picDept: response.picDept || '',
          wrkrRole: response.wrkrRole || '',
        }));
      })
      .catch(error => {});
    return Promise.resolve().then(() => {});
  };

  const searchEnt = () => {
    const param = {
      entNm: searchValue || '',
      brno: searchValue || '',
      searchMethod: searchMethod,
    };
    const url = '/member/entList.do';
    nlPost(url, param)
      .then(response => {
        setEntData(response);
      })
      .catch(error => {});
  };

  const activation = async (paramOne, paramTwo) => {
    const url = '/adminUser/userActivate.do';
    const postParam = {
      userSn: paramOne,
      useYn: paramTwo === 'Y' ? 'Y' : 'N',
      memberType: 'user',
    };

    try {
      const response = await dbPost(url, postParam);
      await getUserInfo();
      if (paramTwo === 'Y') {
        await modalService.successAlert('사용자를 비활성화 하였습니다.');
      } else if (paramTwo === 'N') {
        await modalService.successAlert('사용자를 활성화 하였습니다.');
      }
    } catch (error) {}
  };

  const entSelect = entSn => {
    setShowModal(false);
    setEntData([]);
    setSearchValue('');
    setSearchMethod('entNm');
    const selectedEnt = entData.find(ent => ent.entSn === entSn);
    if (selectedEnt) {
      setFormData(prevFormData => ({
        ...prevFormData,
        entNm: selectedEnt.entNm,
        entSn: selectedEnt.entSn,
        brno: selectedEnt.brno,
      }));
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEntData([]);
    setSearchValue('');
    setSearchMethod('entNm');
  };

  const handleValidateAndCheck = async () => {
    const isValid = await fnValidateEmail(formData.userEml);
    if (isValid) {
      emlDplChk();
    }
  };

  const emlDplChk = () => {
    const url = '/member/duplicateUserEmlChk.do';
    const param = {
      userEml: formData.userEml,
      pageType: 'info',
    };
    nlPost(url, param)
      .then(response => {
        if (response instanceof Error) {
          this.modalService.errorAlert(
            '데이터 처리중 에러가 발생하였습니다',
            () => {}
          );
        } else if (formData.userEml == formData.userOrgnlEml) {
          setDplChkBool(true);
          setUserEmlChg(false);
          modalService.successAlert('사용 가능한 이메일 주소입니다.', () => {
            return;
          });
        } else {
          if (response == true) {
            setDplChkBool(true);
            setUserEmlChg(false);
            modalService.successAlert('사용 가능한 이메일 주소입니다.');
          } else if (response == false) {
            setDplChkBool(false);
            setUserEmlChg(true);
            modalService.errorAlert('사용 불가능한 이메일 주소입니다.');
            setFormData(prevFormData => ({ ...prevFormData, userEml: '' }));
          }
        }
      })
      .catch(error => {});
  };

  const fnValidateEmail = async email => {
    if (!isValidEmail(email)) {
      modalService.errorAlert('이메일 형식이 아닙니다.');
      setFormData(prevFormData => ({ ...prevFormData, userEml: '' }));
      return false;
    } else {
      return true;
    }
  };

  const beforeInsert = async () => {
    const validationRules = {
      userNm: { presence: true },
      userTelno: { presence: true },
      userMblTelno: { presence: true },
      entSn: { presence: true },
      userEml: { presence: true, email: true },
      wrkrRole: { presence: true },
    };

    const altKey = {
      userNm: '이름',
      userTelno: '전화번호',
      userMblTelno: '휴대전화',
      userEml: '이메일',
      entSn: '소속기업',
      wrkrRole: '직책',
    };

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }
    if (dplChkBool == true && userEmlChg == false) {
      updateUserInfo();
    } else {
      modalService.errorAlert('이메일 중복확인을 해주세요.', () => {});
      return;
    }
  };

  const updateUserInfo = () => {
    const url = '/member/updateUserInfo.do';
    const param = {
      userNm: formData.userNm,
      userSn: formData.userSn,
      userId: formData.userId,
      userTelno: formData.userTelno,
      userMblTelno: formData.userMblTelno,
      userEml: formData.userEml,
      entSn: formData.entSn,
      userType: formData.userType,
      picDept: formData.picDept,
      wrkrRole: formData.wrkrRole,
    };

    dbPost(url, param)
      .then(response => {
        modalService.successAlert('사용자 정보를 수정하였습니다.', () => {
          navigate('/member/adminUser/adminPersonalUser');
        });
      })
      .catch(error => {});
  };

  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleSearchMethodChange = e => {
    setSearchMethod(e.target.value);
  };

  const openModal = () => {
    searchEnt();
    setShowModal(true);
  };

  const handleInputChangeName = e => {
    const { id, value } = e.target;
    // 숫자가 포함되지 않은 경우에만 상태를 업데이트
    if (!/\d/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    }
  };

  // 아이디 비밀번호 입력 input 스페이스 금지
  const handleKeyDown = e => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  // 아이디 비밀번호 입력 input 붙여넣기 금지
  const handlePaste = e => {
    e.preventDefault();
  };

  const handleInputChangeEml = e => {
    const { id, value } = e.target;
    // 한글이 포함되지 않은 경우에만 상태를 업데이트
    if (!/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    }
    setUserEmlChg(false);
    setDplChkBool(false);
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자관리</h2>
      </div>
      {/* //페이지 타이틀 영역 */}
      {/* table list */}
      <div className="tbl-wrap">
        <h3 className="block-tit">사용자 정보</h3>
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">
                아이디 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <p>
                    <strong>{formData.userId}</strong>
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                이름 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="userNm">
                    라벨
                  </label>
                  <input
                    type="text"
                    id="userNm"
                    value={formData.userNm || ''}
                    onChange={handleInputChangeName}
                    className="form-control md"
                    placeholder="이름 입력"
                    aria-labelledby="userNm"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                전화번호 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="userTelno">
                    라벨
                  </label>
                  <NumericFormat
                    type="text"
                    id="userTelno"
                    className="form-control"
                    value={formData.userTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    placeholder="전화번호 입력"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                휴대전화 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="userMblTelno">
                    라벨
                  </label>
                  <NumericFormat
                    type="text"
                    id="userMblTelno"
                    className="form-control"
                    value={formData.userMblTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    allowNegative={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    placeholder="휴대전화 입력"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                이메일주소 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="userEml">
                    라벨
                  </label>
                  <input
                    type="text"
                    id="userEml"
                    className="form-control"
                    value={formData.userEml || ''}
                    onChange={handleInputChangeEml}
                    onKeyDown={handleKeyDown} // 아이디 스페이스바 금지
                    onPaste={handlePaste} // 아이디 붙여넣기 금지
                    maxLength={50}
                    placeholder="이메일 주소 입력"
                    aria-labelledby="userEml"
                  />
                  <button
                    type="button"
                    className="btn secondary"
                    onClick={() => {
                      handleValidateAndCheck();
                    }}
                  >
                    중복검사
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                부서 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="picDept">
                    라벨
                  </label>
                  <input
                    type="text"
                    id="picDept"
                    value={formData.picDept || ''}
                    onChange={handleInputChange}
                    className="form-control md"
                    placeholder="부서 입력"
                    aria-labelledby="picDept"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                직책 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="wrkrRole">
                    라벨
                  </label>
                  <input
                    type="text"
                    id="wrkrRole"
                    value={formData.wrkrRole || ''}
                    onChange={handleInputChange}
                    className="form-control md"
                    placeholder="직책 입력"
                    aria-labelledby="wrkrRole"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* //table list */}
      {/* table list */}
      <div className="tbl-wrap">
        <h3 className="block-tit">소속 기업</h3>
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">기업명</th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="entNm">
                    라벨
                  </label>
                  <input
                    type="text"
                    id="entNm"
                    value={formData.entNm || ''}
                    className="form-control md"
                    placeholder="기업명 입력"
                    disabled
                    aria-labelledby="entNm"
                  />{' '}
                  <button
                    type="button"
                    className="btn md secondary"
                    onClick={() => {
                      openModal();
                    }}
                  >
                    검색
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">사업자등록번호</th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="brNo">
                    라벨
                  </label>
                  <input
                    type="text"
                    id="brNo"
                    className="form-control md"
                    placeholder="사업자등록번호 입력"
                    value={formData.brno || ''}
                    readOnly
                    aria-labelledby="brNo"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* //table list */}

      <div className="page-btn-wrap both">
        <button
          type="button"
          className="btn xlg tertiary"
          onClick={() => {
            activation(formData.userSn, formData.useYn);
          }}
        >
          {formData.useYn === 'Y' ? '비활성화' : '활성화'}
        </button>
        <button
          type="button"
          className="btn xlg primary"
          onClick={() => {
            beforeInsert();
          }}
        >
          저장
        </button>
      </div>
      {showModal && (
        <div
          className="modal fade in shown"
          role="dialog"
          aria-labelledby="tit_search_pwd"
          aria-hidden={!showModal}
        >
          <div className="modal-dialog sm">
            <div className="modal-content">
              <div className="modal-header">
                <h2 id="tit_search_corp" className="modal-title">
                  기업정보검색
                </h2>
              </div>
              <div className="modal-conts">
                <div className="txt-box search-corp">
                  <fieldset>
                    <legend>기업검색</legend>
                    <div className="form-group">
                      <div className="form-conts">
                        <label className="hidden-label" htmlFor="searchEnt">
                          라벨
                        </label>
                        <select
                          className="form-select"
                          title="선택"
                          id="searchEnt"
                          value={searchMethod || ''}
                          style={{ width: '50%' }}
                          onChange={handleSearchMethodChange}
                          aria-labelledby="searchEnt"
                        >
                          <option value="entNm">기업명</option>
                          <option value="brno">사업자등록번호</option>
                        </select>
                        <div className="input-group">
                          <label className="hidden-label" htmlFor="searchValue">
                            라벨
                          </label>
                          <input
                            type="text"
                            id="searchValue"
                            value={searchValue || ''}
                            className="form-control"
                            aria-labelledby="searchValue"
                          />
                          <button
                            type="button"
                            className="btn secondary"
                            onClick={() => {
                              searchEnt();
                            }}
                          >
                            검색
                          </button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                {/* 기업정보 테이블 시작*/}
                {entData.length > 0 && (
                  <div className="tbl-wrap">
                    <table className="tbl col data">
                      <caption>
                        기업정보 검색 표로 선택, 사업체명, 사업자등록번호
                        주소등으로 구성되어있음
                      </caption>
                      <colgroup>
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '10%' }} />
                        <col />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">선택</th>
                          <th scope="col">사업체명</th>
                          <th scope="col">사업자등록번호</th>
                          <th scope="col">주소</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entData.map(entData => (
                          <tr key={entData.entSn}>
                            <th>
                              <button
                                type="button"
                                className="btn primary"
                                onClick={() => {
                                  entSelect(entData.entSn);
                                }}
                              >
                                선택
                              </button>
                            </th>
                            <td>{entData.entNm}</td>
                            <td>{entData.brno}</td>
                            <td>{entData.entAddr}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {/* 기업정보 테이블 끝*/}
              </div>
              <div className="modal-btn btn-wrap"></div>
              <button
                type="button"
                className="btn-close close-modal"
                onClick={() => {
                  closeModal();
                }}
              >
                <span className="sr-only">닫기</span>
              </button>
            </div>
          </div>
          <div className="modal-back in"></div>
        </div>
      )}
    </>
  );
};

export default AdminUserInfo;
